import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { ApiUserPermissions, Security, User } from 'store';
import { environment } from 'environments';

const SECURITY_CONTROLLER_BASE_URL = `${environment.baseApiUrl}security`;

export const fetchCurrentUserSecurity = createAsyncThunk('get:security', async () => {
  const {
    data: { privileges },
  } = await axios.get<Security>(SECURITY_CONTROLLER_BASE_URL);

  return privileges;
});

export const fetchEmployeeData = async (id: number) => {
  const { data } = await axios.get<User>(`${SECURITY_CONTROLLER_BASE_URL}/employees/${id}`);

  return data;
};

export const fetchUsersPermissions = createAsyncThunk('get:security/all', async () => {
  const { data } = await axios.get<ApiUserPermissions[]>(`${SECURITY_CONTROLLER_BASE_URL}/all`);

  return data;
});

export const updateUserPermissions = createAsyncThunk('put:security', async (userPermissions: ApiUserPermissions) => {
  await axios.put(SECURITY_CONTROLLER_BASE_URL, userPermissions);

  return userPermissions;
});
